import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import Swal from 'sweetalert2';


export const authGuardFn: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  const requiredPermission = next.data['permisos'];
    
  const autenticacion = loginService.isLoggedIn();
  if (!autenticacion) {
    router.navigate(['/login']).then(() => {
      Swal.fire({
        title: 'Oops...',
        text: 'Por favor, inicia sesión para acceder.',
      });
    });
    return false;
  } else {
    if (requiredPermission && !loginService.verificarPermisos(requiredPermission)) {
      router.navigate(['/login']).then(() => {
        Swal.fire({
          title: 'Oops...',
          text: 'No posees permisos para acceder a la siguiente ruta.',
        });
      });
      return false;
    }
    
    return true;
  }
};
